var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOtnosheniya(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 154,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#otnosheniya_svg__clip0_632_7123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.182 39.947s10.756-3.798 15.773 2.448c5.017 6.247 5.448 9.462 9.647 8.922 11.165-1.445 9.216 6.97 11.283 10.087 2.067 3.118 7.634-.302 10.691 6.387 8.506 18.62-26.507 34.49-41.193 26.334-14.685-8.156-18.636-3.215-15.966-13.917 1.13-4.541 4.77-4.25 1.97-7.325s-4.64-2.567-5.373-6.397c-.732-3.83-1.604-22.483 13.168-26.54z",
    fill: "#333",
    stroke: "#333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.83 107.395s4.178 26.949 19.639 46.605l-68.088-.539.344-38.439 48.105-7.627z",
    fill: "#FF755F",
    stroke: "#FF755F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.754 42.127s-1.335-3.442-4.231-3.172c-3.822.356-5.2 13.324 7.31 17.65",
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.754 42.127s-1.335-3.442-4.231-3.172c-3.822.356-5.2 13.324 7.31 17.65",
    stroke: "#333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.392 35.156c-.398-.798-.086-10.335-11.886-15.438-10.874-4.703-20.381-3.117-26.195 6.096-5.846 9.267-.086 36.885 12.414 44.922 0 0-.173 9.968-6.955 13.507 0 0 14.179 7.239 23.255 3.528 9.076-3.711 9.367-6.797 9.367-6.797s-6.287-18.178-4.08-26.647c2.207-8.469 4.08-19.17 4.08-19.17z",
    fill: "#FCFCFD",
    stroke: "#333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.321 153.461c-13.157-66.262-43.11-74.493-43.11-74.493-22.394 8.738-30.512 0-30.512 0C27.247 88.807 19 153.979 19 153.979l115.321-.518z",
    fill: "#FFA192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.812 44.51s1.722-.172 3.014 1.413M51.246 51.221l-1.917-6.43M79.26 64.285s-6.869 10.41-14.534 6.44",
    stroke: "#333",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.64 15.414c-3.972-1.413-8.311-1.564-12.316-.237-2.821.939-5.545 2.524-6.816 5.221-3.165 6.754 4.76 23.778 19.025 18.535 14.266-5.243 19.81-7.023 21.802-3.453 1.981 3.571 1.81 15.492 4.07 14.295 2.272-1.187.635-12.158 1.68-13.075 1.044-.917 5.318-.227 5.318-3.41 0-3.171-3.768-17.487-18.4-17.077-6.406.194-11.078.356-14.362-.799z",
    fill: "#333",
    stroke: "#333",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.406 36.84s3.596-5.232 6.46-2.805c6.137 5.222.323 18.48-6.837 19.721",
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.406 36.84s3.596-5.232 6.46-2.805c6.137 5.222.323 18.48-6.837 19.721M87.541 42.396s3.025-3.755 4.953-3.453M88.849 47.768L90 39.947",
    stroke: "#333",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.002 95.959s-19.11 13.615-26.593 11.435c-7.483-2.168-11.014-11.877-11.014-11.877l3.122-4.629C103.6 90.155 95.169 79.464 91.606 68.32c-1.561-4.876-2.186-9.839-1.69-14.09 1.528-13.075 13.824-13.851 13.824-13.851s12.327-1.974 18.486 12.6c.56 1.327 1.044 2.525 1.475 3.625 4.231 10.972 2.164 11.468 5.135 19.333 3.263 8.652 4.673 14.478 10.659 17.207 5.987 2.73 9.507 2.816 9.507 2.816z",
    fill: "#FCFCFD",
    stroke: "#333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.168 84.05s-3.714 7.238-9.657 6.84c-15.687-1.047-26.25-22.656-24.602-36.67 1.529-13.075 13.824-13.852 13.824-13.852",
    stroke: "#333",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.948 101.613c.356.086 15.493-1.5 20.694-9.354 0 0 5.071.712 9.42 2.827 10.455 5.059 22.169 13.798 29.985 22.86 9.367 10.864 7.427 21.246 4.736 25.14-8.172 11.803-19.68 10.386-33.17 2.23-10.605-6.408-29.996-30.207-29.996-30.207l-1.669-13.496z",
    fill: "#FF755F",
    stroke: "#FF755F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.569 92.259c-.194-.044-4.188-5.686-4.188-6.592 0-2.255 5.825.744 9.797 9.202 3.984 8.448-5.609-2.61-5.609-2.61z",
    fill: "#FCFCFD",
    stroke: "#333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.698 84.933c1.28-.798 12.22-.021 18.863 5.729l15.148 14.715-5.943 8.997s-3.445-2.19-6.341-3.225c-7.246-2.622-6.213-6.959-9.486-10.077-3.284-3.107-7.741-4.52-9.604-4.984-2.336-.572-3.434-2.211-.925-2.557 0 0-2.175-.7-2.51-1.737-.333-1.035 1.713-1.24 1.713-1.24s-2.638-.594-2.057-2.32c.313-.927 2.757-.647 3.08-.604.01 0 .01-.01 0-.01-.356-.14-3.661-1.597-1.938-2.687z",
    fill: "#FCFCFD",
    stroke: "#333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.41 90.317s-4.953-2.395-9.766-2.687l9.766 2.687z",
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.41 90.317s-4.953-2.395-9.766-2.687",
    stroke: "#333",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.013 93.315c-.129 0-8.01-2.999-10.39-2.762l10.39 2.762z",
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.013 93.315c-.129 0-8.01-2.999-10.39-2.762",
    stroke: "#333",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.014 96.445c-.086 0-6.783-2.6-9.604-2.913l9.604 2.913z",
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.014 96.445c-.086 0-6.783-2.6-9.604-2.913",
    stroke: "#333",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.857 111.754c-15.063-.27-40.138-7.682-40.138-7.682l-7.418 10.303s15.719 25.601 46.813 24.446",
    fill: "#FF755F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.857 111.754c-15.063-.27-40.138-7.682-40.138-7.682l-7.418 10.303s15.719 25.601 46.813 24.446",
    stroke: "#FF755F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.119 122.984c-15.977-2.115-41.397-18.901-41.397-18.901l-7.774 10.303s12.812 18.146 37.489 31.081M67.103 46.538c.27 0 4.996-3.484 8.69-1.068M55.477 49.193c.356-.464 4.049-2.643 6.784-.702",
    stroke: "#333",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.55 46.324l7.666-3.431a.713.713 0 01.948.367.716.716 0 01-.366.949l-.076.032-8.01 2.514a.23.23 0 01-.29-.151.24.24 0 01.129-.28zM66.111 41.78a2.33 2.33 0 01.377-.161c.14-.033.13-.022.205-.033.107-.01.226-.032.323-.032l.581-.043 1.141-.043 2.272-.054 4.522-.043a.23.23 0 01.237.226.243.243 0 01-.205.237l-4.478.572-2.23.313-1.097.173-.539.097c-.097.01-.161.043-.236.054-.022.01-.119.021-.065.021.043-.01.086-.032.108-.064a.766.766 0 01-1.066-.151.771.771 0 01.15-1.068z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.009 47.693s-.162 2.179 1.087 2.556c1.895.572 1.949-1.91 1.949-1.91l-3.036-.646zM71.447 45.06s-.183 2.708 1.625 2.946c2.025.259 2.487-2.676 2.487-2.676s-2.971-1.596-4.112-.27z",
    fill: "#333",
    stroke: "#333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.874 43.173c.032.183 2.39 13.766 2.756 15.902a.284.284 0 00.334.226l3.908-.744",
    stroke: "#333",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.597 62.71a.172.172 0 01-.182-.215c.118-.496.656-1.554 2.971-1.295 1.184.13 1.701.593 1.916.895.087.108.011.27-.129.281l-4.576.335z",
    fill: "#FF755F",
    stroke: "#FF755F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.705 60.455c-7.43-3.225-9.895.907-10.39 1.996-.054.108.043.227.162.205l10.206-1.92c.14-.033.151-.227.022-.28z",
    fill: "#333",
    stroke: "#333",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.302 67.954s4.446 8.414 4.242 11.953c0 .075.064.13.129.108l3.897-1.263",
    stroke: "#333",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.617 64.058l8.71-1.338a.233.233 0 01.269.194.23.23 0 01-.172.26l-8.57 2.017a.582.582 0 01-.269-1.133c0 .01.01.01.032 0z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.445 69.884s1.368-5.21 6.514-4.013",
    stroke: "#333",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.579 66.486c.226-.022 1.281 2.772 0 3.743-1.163.885-2.821-.561-2.821-.561s.753-2.956 2.821-3.183z",
    fill: "#333",
    stroke: "#333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.498 75.817s1.367-5.21 6.514-4.013",
    stroke: "#333",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.621 72.419c.226-.022 1.281 2.773 0 3.743-1.163.885-2.821-.56-2.821-.56s.754-2.957 2.821-3.183z",
    fill: "#333",
    stroke: "#333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.472 72.732l5.502-5.114a.45.45 0 01.624.022.453.453 0 01-.021.626l-.022.021-5.749 4.758-.043.032a.225.225 0 01-.323-.032c-.065-.097-.054-.237.032-.313zM115.832 81.751c.054-.032.032-.108-.032-.108-1.195.044-3.413-.658-4.759-.29-1.12.301-1.346 1.499-1.389 2.027a.284.284 0 00.248.302c.495.054 1.669.108 2.831-.388 1.195-.518 2.563-1.251 3.101-1.543z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.414 117.946v17.876M110.094 117.946v17.876M57.769 84.221s12.08 7.023 31.976-.496",
    stroke: "#333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.958 98.042s-2.154 6.71-12.393 7.39",
    stroke: "#333",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.557 53.917c2.864 1.457 6.633 2.708 11.144 2.74-.42-1.1-.915-2.297-1.475-3.624-6.159-14.575-18.486-12.612-18.486-12.612s-12.296.777-13.825 13.852c-.495 4.262.13 9.224 1.69 14.09 0 .01 14.934-4.423 20.952-14.446z",
    fill: "#333",
    stroke: "#333",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.946 58.136s.883-5.793 4.759-5.103c3.876.69 5.545 6.516 5.545 9.246 0 2.73-1.583 8.005-4.317 8.89",
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.946 58.136s.883-5.793 4.759-5.103c3.876.69 5.545 6.516 5.545 9.246 0 2.73-1.583 8.005-4.317 8.89M123.003 62.958s.183-5.2 3.37-5.653M125.76 65.871l-1.41-7.292",
    stroke: "#333",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "otnosheniya_svg__clip0_632_7123"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h167v154H0z"
  })))));
}
export default __webpack_public_path__ + "static/otnosheniya.cb5af860.svg";
export { SvgOtnosheniya as ReactComponent };